import { resolveMeetOrigin } from '../services/meetingWindow/meetOrigin';

export type CalendarProvider = 'google' | 'microsoft';

export type CalendarOauthMessage = {
  type: 'calendar-connected' | 'calendar-disconnected';
  provider: CalendarProvider;
  success: boolean;
};

/** True when a postMessage about calendar OAuth came from this page or Meet's origin. */
export const isTrustedCalendarMessageOrigin = (origin: string): boolean => {
  if (typeof window === 'undefined') {
    return false;
  }
  if (origin === window.location.origin) {
    return true;
  }
  try {
    return origin === resolveMeetOrigin();
  } catch {
    return false;
  }
};

/**
 * OAuth popup return URL. In TeamHub the page origin is the host, so redirect
 * to Meet's own `/close` route (served by the Meet remote) instead.
 */
export const buildCalendarOauthCloseUrl = (provider: CalendarProvider): string =>
  `${resolveMeetOrigin()}/close?provider=${provider}`;

export const notifyCalendarOauthResult = (message: CalendarOauthMessage): void => {
  if (typeof window === 'undefined') {
    return;
  }
  window.postMessage(message, window.location.origin);
};
